<template>
  <div>
    <v-row
      justify="end"
      align="center"
      class="pr-2 pl-2 wz-report-week-toolbar"
      no-gutters
    >
      <v-col justify="start" align="start" cols="2">
        <v-select
          v-model="selectedClientId"
          :items="clientList"
          item-text="name"
          item-value="clientId"
          label="Client"
          @change="updateReports()"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="selectedNoWeeks"
          :items="noWeeks"
          item-text="name"
          item-value="value"
          label="Weeks"
          class="pl-3"
          @change="updateReports()"
        ></v-select>
      </v-col>
      <v-col justify="end" align="end">
        <v-btn tile color="primary" @click="updateReports()">Update</v-btn>
      </v-col>
    </v-row>

    <v-row class="pb-3" no-gutters>
      <v-col
        v-for="(week, i) in reportWeeks"
        :key="i"
        cols="12"
        v-show="i + 1 <= selectedNoWeeks"
      >
        <div class="ma-2">
          <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
            <h2 class="pb-4 pt-4">
              {{ getStartOfWeek(week.weekOffset) }}
              to
              {{ getEndOfWeek(week.weekOffset) }}
            </h2>
          </v-row>
          <v-data-table
            disable-filtering
            :hide-default-footer="true"
            disable-sort
            class="wz_data_table elevation-2"
            dense
            :loading="!week.report.loaded"
            :headers="headers"
            :items="week.report.data"
            item-key="name"
          >
            <template v-slot:body.append="{ headers }">
              <tr>
                <td v-for="(header, i) in headers" :key="i">
                  <div v-if="i === 0">Total</div>

                  <div
                    class="font-weight-bold"
                    v-else-if="header.type !== 'string'"
                  >
                    {{
                      week.report.data
                        .map((d) => d[headers[i].value])
                        .reduce((sum, val) => (sum += val), 0)
                    }}
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import api from "../services/support.api";

/* eslint-disable no-undef */

export default {
  data() {
    return {
      selectedNoWeeks: 4,
      noWeeks: [
        { name: "2 weeks", value: 2 },
        { name: "3 weeks", value: 3 },
        { name: "4 weeks", value: 4 },
        { name: "5 weeks", value: 5 },
        { name: "6 weeks", value: 6 },
      ],
      headers: [
        { text: "Device", value: "DEVICE" },
        { text: "Available Traffic", value: "TOTALAVAILABLETRAFFIC" },
        { text: "Unique Traffic", value: "UNIQUETRAFFIC" },
        { text: "Repeat Traffic", value: "REPEATTRAFFIC" },
        { text: "Filtered Traffic", value: "FILTEREDTRAFFIC" },
        { text: "Failed To INIT", value: "FAILEDTOINIT" },
        {
          text: "Available To Serve",
          value: "AVAILABLETOSERVE",
        },
        { text: "Exit without event", value: "PAGEEXITWITHOUTEVENT" },
        { text: "Popups served", value: "POPUPSSERVED" },
        { text: "Popups suppressed", value: "POPUPSUPPRESSED" },
        { text: "Leads captured", value: "LEADSCAPTURED" },
        { text: "Conversion Rate", value: "CONVERSIONRATE", type: "string" },
      ],
      clientList: [{ name: "Citation", id: 13 }],
      selectedClientId: 13,
      reportWeeks: [
        {
          name: "1 week",
          weekOffset: 0,
          report: { loaded: false, data: [] },
        },
        {
          name: "2 weeks",
          weekOffset: -1,
          report: { loaded: false, data: [] },
        },
        {
          name: "3 weeks",
          weekOffset: -2,
          report: { loaded: false, data: [] },
        },
        {
          name: "4 weeks",
          weekOffset: -3,
          report: { loaded: false, data: [] },
        },
        {
          name: "5 weeks",
          weekOffset: -4,
          report: { loaded: false, data: [] },
        },
        {
          name: "6 weeks",
          weekOffset: -5,
          report: { loaded: false, data: [] },
        },
      ],
    };
  },
  async created() {
    this.clientList = await api.getClientList();
    this.updateReports();
  },
  methods: {
    async updateReports() {
      for (let i = 0; i < this.reportWeeks.length; i++) {
        const week = this.reportWeeks[i];

        // convert dateTimes so they are ok for snowflake
        const startDateTime = this.getStartOfWeek(week.weekOffset);
        const endDateTime = this.getEndOfWeek(week.weekOffset);

        this.getReport(i, startDateTime, endDateTime);
      }
    },
    getStartOfWeek(offset) {
      return moment().add(offset, "w").startOf("isoweek").format("YYYY-MM-DD");
    },
    getEndOfWeek(offset) {
      return moment().add(offset, "w").endOf("isoweek").format("YYYY-MM-DD");
    },
    async getReport(reportIndex, startDateTime, endDateTime) {
      // reset the data for the given week
      this.reportWeeks[reportIndex].report.data = [];
      this.reportWeeks[reportIndex].report.loaded = false;

      // only load the data for the week if it falls
      // inside the selected duration
      if (reportIndex + 1 <= this.selectedNoWeeks) {
        this.reportWeeks[reportIndex].report.data = await api.getReport(
          "device",
          this.selectedClientId,
          startDateTime,
          endDateTime
        );

        this.reportWeeks[reportIndex].report.loaded = true;
      }
    },
  },
};
</script>
<style>
</style>